import { createSlice, createAction } from "@reduxjs/toolkit";

export const initialState = {
  status: {},
};

export const slice = createSlice({
  name: "boarding",
  initialState,
  reducers: {
    setStatus(state, action) {
      state.status = action.payload;
    },
    updateStatusItem(state, action) {
      state.status[action.payload.key] = action.payload.value;
    },
  },
});

export const { setStatus, updateStatusItem } = slice.actions;

export const fetchBoardingStatus = createAction("fetchBoardingStatus");
export const switchToProduction = createAction("switchToProduction");
export const requestApproval = createAction("requestApproval");

export const selectBoardingStatus = (state) => state.boarding.status || {};

export default slice.reducer;
